import underscore from 'vue-underscore';
// window.$_ = underscore;
export default ({Vue}) => {
  Vue.use(underscore);
}
